import React, {} from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

const NotFound = () => {

    return (
        <div>
            <h2>404</h2>
            <Row xs="12">
                <Col>
                    <Card>
                        <CardBody>
                            <p>Page not found!</p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default NotFound